import React from 'react';

const AdminDashboard: React.FC = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-black dark:text-white">Admin Dashboard</h1>
      <p className="text-body">Welcome, Superuser. Use the Admin menu to manage users, schools, exams, and students.</p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="rounded border border-stroke p-4 dark:border-strokedark">
          <h2 className="font-semibold mb-2">System Overview</h2>
          <p className="text-sm text-body">This is a placeholder dashboard. Integrate real metrics as needed.</p>
        </div>
        <div className="rounded border border-stroke p-4 dark:border-strokedark">
          <h2 className="font-semibold mb-2">Quick Actions</h2>
          <ul className="list-disc pl-5 text-sm">
            <li>Manage Users</li>
            <li>Manage Schools</li>
            <li>Manage Exams</li>
            <li>Manage Students</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
